import checkbox from './sparkCheckboxLayout'
import radio from './sparkCheckboxLayout'
import date from './sparkDateLayout'
import list from './list'
import select from './sparkSelectLayout'
import struct from './struct'
import textbox from './sparkInputLayout'
//import number from './sparkNumberLayout'

export default {
    checkbox,
    date,
    list,
    radio,
    select,
    struct,
    textbox
}



// WEBPACK FOOTER //
// ./src/shared/components/tcomb/semantic.js